'use client';

import React from 'react';

export const FreestarPrivacyManager: React.FC = () => (
  <>
    <style>{`
      #pmLink {
        visibility: hidden;
        text-decoration: none;
        cursor: pointer;
        background: transparent;
        border: none;
        padding: 0;
        margin: 0;
        font: inherit;
        color: inherit;
      }
      #pmLink:hover {
        visibility: visible;
        color: grey;
      }
    `}</style>
    <button id="pmLink" type="button">
      Privacy Manager
    </button>
  </>
);
